export default __webpack_public_path__ + "static/media/ponente-Manuel.dc35c90d.png";